import {Construtor} from './construtor';

export class AgendaRoteiroSetor implements Construtor<AgendaRoteiroSetor> {

  public idAgendaRoteiroSetor: number;
  public idAgendaRoteiroPontoFisico: number;
  public idSetorPontoFisico: number;
  public selecionado: boolean;
  public alterado: boolean;

  constructor(object?: any) {
    if (object !== undefined) {
      if (object instanceof (AgendaRoteiroSetor)) {
        this.copyObject(object);
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }
    }
  }

  parseFromJson(indicadorSetor: any): void {
    this.idAgendaRoteiroSetor = indicadorSetor.idAgendaRoteiroSetor;
    this.idSetorPontoFisico = indicadorSetor.idSetorPontoFisico;
    this.idAgendaRoteiroPontoFisico = indicadorSetor.idAgendaRoteiroPontoFisico;
  }

  copyObject(indicadorSetor: AgendaRoteiroSetor): void {
    this.idAgendaRoteiroSetor = indicadorSetor.idAgendaRoteiroSetor;
    this.idSetorPontoFisico = indicadorSetor.idSetorPontoFisico;
    this.idAgendaRoteiroPontoFisico = indicadorSetor.idAgendaRoteiroPontoFisico;
  }

  modeloCompleto(): boolean {
    return this.idSetorPontoFisico !== undefined && this.idAgendaRoteiroPontoFisico !== undefined;
  }

  getNewInstance(object?: any): AgendaRoteiroSetor {
    return new AgendaRoteiroSetor(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/agenda-roteiro-setor.ts